var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveChip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website_2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.733577013,0.733565171 C1.044977,0.422158737 1.54726328,0.422158737 1.85880909,0.733565171 L9.6463189,8.52147399 L9.99987596,8.87504917 L18.1412737,0.733482405 C18.4525771,0.422172532 18.9550368,0.422172532 19.2663402,0.733482405 C19.577859,1.04486186 19.577859,1.54722218 19.266423,1.85851887 L11.4787368,9.64660393 L11.1252106,10.0001483 L19.2663348,18.1416896 C19.577859,18.4530744 19.577859,18.9554347 19.266423,19.2667314 C19.1148309,19.4183266 18.9136546,19.5 18.703807,19.5 C18.4939592,19.5 18.292783,19.4183266 18.1412737,19.2668142 L10.3534384,11.4788172 L9.99987596,11.1252474 L1.85872092,19.2668196 C1.70721702,19.4183266 1.50604076,19.5 1.29619308,19.5 C1.08628548,19.5 0.884996865,19.4182966 0.733825811,19.2669803 C0.422140996,18.9554347 0.422140996,18.4530744 0.733577013,18.1417777 L8.87478944,10.0001483 L8.52126321,9.64660393 L0.733665181,1.85860702 C0.422140996,1.54722218 0.422140996,1.04486186 0.733577013,0.733565171 Z",
    id: "Combined-Shape",
    fill: "#9E9E9E",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveChip);
export default __webpack_public_path__ + "static/media/removeChip.fd413ba95d695f9f4407b3f09b84495a.svg";
export { ForwardRef as ReactComponent };